var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container-fluid" }, [
    _c("div", { staticClass: "row no-margin-left-right-for-header" }, [
      _c(
        "div",
        { staticClass: "col-sm-12 no-padding-right navigator-container" },
        [
          _c("div", { staticClass: "title-dashboard title-text pl-0" }, [
            _vm._v("Dashboard")
          ]),
          _vm._v(" "),
          _c(
            "ul",
            { staticClass: "menu-list" },
            _vm._l(_vm.navItems, function(item, index) {
              return !item.overview
                ? _c(
                    "li",
                    {
                      key: item.url,
                      staticClass: "menu-item",
                      class: { active: item.active },
                      on: {
                        click: function($event) {
                          _vm.clickItem(item)
                        }
                      }
                    },
                    [_vm._v("\n          " + _vm._s(item.text) + "\n        ")]
                  )
                : _vm._e()
            })
          )
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6d866af6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d866af6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/commons/Navigator.vue
// module id = 1574
// module chunks = 1